<template>
  <div class="timeline">
    <div class="entry" v-for="(items, idx) in data" :key="'epgradio-' + idx">
      <div v-if="getCurrentEpgDesc(items.dateTimeStart, items.dateTimeEnd)">
        <div class="title active">
          <h3>{{ timeConverter(items.dateTimeStart) }}</h3>
        </div>
        <div class="wrapper active">
          <p>
            {{ items.scheduleProgramTitle }}
          </p>
          <span class="desc">
            <!-- {{ truncateString(items.scheduleProgramDescription, 150) }} -->
            {{ items.scheduleProgramDescription }}
          </span>
        </div>
      </div>
      <div v-else>
        <div class="title">
          <h3>{{ timeConverter(items.dateTimeStart) }}</h3>
        </div>
        <div class="wrapper">
          <p>
            {{ items.scheduleProgramTitle }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'timeline-jadual-radio',
  props: ['data'],
};
</script>

<style scoped>
.timeline {
  width: 100%;
  min-height: 100%;
  overflow: auto;
  max-width: 800px;
  padding: 24px 16px;
  position: relative;
  box-shadow: 0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2);
}
.timeline:before {
  content: '';
  position: absolute;
  top: 0px;
  left: 139px;
  bottom: 0px;
  width: 4px;
  background: #d9e021;
}
.timeline:after {
  content: '';
  display: table;
  clear: both;
}

.entry {
  clear: both;
  text-align: left;
  position: relative;
}
.entry .title {
  margin-bottom: 0.5em;
  float: left;
  width: 120px;
  padding-right: 28px;
  text-align: right;
  position: relative;
}

.entry .title:before {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  border: 8px solid #d9e021;
  border-radius: 100%;
  top: 15%;
  right: -13px;
  z-index: 99;
}
.entry .title h3 {
  color: #fff;
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.entry .title.active h3 {
  color: #d9e021;
}
.entry .title p {
  margin: 0;
  font-size: 100%;
}
.entry .wrapper {
  margin: 0 0 36px;
  width: auto;
  padding-left: 148px;
}
.entry .wrapper p {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.entry .wrapper.active p {
  font-weight: 700;
  color: #d9e021;
  margin-bottom: 4px;
}

.entry .wrapper.active span {
  color: #fff;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.5px;
}
.entry .wrapper p:first-child {
  margin-top: 0;
}
.entry .wrapper ul {
  color: #aaa;
  padding-left: 0;
  list-style-type: none;
}
.entry .wrapper ul li:before {
  content: '–';
  margin-right: 0.5em;
}
</style>
